import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledListAppsContainer = styled('div')`
  .transaction-history-loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .list-apps-card {
    margin: 16px 4px;
    min-height: 100vh;
    .voice-library-banner {
      padding: 0 24px;
    }
  }

  .list-apps-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1135px;
    margin: 0 auto;
  }
`;

export const StyledListAppsHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid ${COLOR.borderDropdown};

  .container-btn {
    display: flex;
    align-items: center;
  }

  .icon-btn-tooltip-refer-and-get-reward {
    border-radius: 0;
    padding: 0;
    &:hover {
      background: transparent;
    }
    .zoom-image {
      animation: zoomInOut 1s infinite ease-in-out;
    }

    @keyframes zoomInOut {
      0% {
        transform: scale(1.1);
      }
      50% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const StyledList = styled('div')`
  padding: 24px;
  padding-bottom: 0;
`;

export const StyledApiTtsSttLaunchBanner = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 12px;
  border: 0.5px solid ${COLOR.orangeV2[100]};
  background: linear-gradient(
      90deg,
      ${COLOR.orangeV2[8]} 0%,
      ${COLOR.orangeV2[8]} 100%
    ),
    linear-gradient(90deg, #fff 0%, #fff 100%);
  margin: 24px 24px 0;

  .banner-icon {
    font-size: 20px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .banner-text {
    flex: 1;
  }

  .banner-link {
    color: ${COLOR.blueV2};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .banner-close {
    flex-shrink: 0;
    padding: 0;
    color: ${COLOR.label2[64]};
  }
`;
